<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top border-bottom navbar-expand"
    :class="{ 'bg-info navbar-dark': type === 'default' }"
  >
    <!-- Sidebar toggler (mobile) + the page taskbar.
         The "MadameFin Backoffice : <env>" title that used to sit here is gone
         on the owner's instruction (2026-10-03) — the document <title> in
         public/index.html still carries it, and Login.vue still shows it. The
         space it occupied is now the taskbar of open pages. -->
    <div class="navbar-brand-row d-flex align-items-center flex-grow-1 min-width-0">
		<a href="#" class="text-white mr-2 d-lg-none"  @click.prevent="toggleSidebar()">
		<i class="fa fa-solid fa-bars d-md-block d-lg-none"  aria-hidden="true"></i>
		</a>
		<page-taskbar />
    </div>


    <div class="navbar-nav align-items-center ml-md-auto">
      <!-- The EN/TH buttons that sat here moved into the user menu below as a
           single toggle (owner 2026-10-06, docs/specs/2026-10-06-bo-language-
           toggle-user-menu-design.md L1/L2). -->
      <ul class="navbar-nav align-items-center ml-md-auto">
        <base-dropdown
          menu-on-right
          class="nav-item"
          tag="li"
          title-tag="a"
          title-classes="nav-link pr-0"
        > 
          <a
            href="#"
            class="nav-link pr-0"
            @click.prevent
            slot="title-container"
          >
            <div class="media align-items-center">
              <div class="media-body ml-2 d-none d-lg-block">
                <span class="mb-0 text-sm  font-weight-bold">{{
                  getUser.fname + "  " + getUser.lname
                }} </span>
              </div>
            </div>
          </a> 

          <template>
            <div class="dropdown-header noti-title">
              <h6 class="text-overflow m-0">{{ $t("welcome")  }}</h6>
            </div>
            <router-link :to="{ name: 'ProfileChange' }">
              <a href="#" class="dropdown-item">
                <i class="ni ni-single-02"></i>
                <span>{{ $t("myprofile") }} </span>
              </a>
            </router-link>
            <router-link :to="{ name: 'ProfileChangePassword' }">
              <a href="#" class="dropdown-item">
                <i class="fa fa-key"></i>
                <span>{{ $t("changepassword") }} </span>
              </a>
            </router-link>
            <router-link :to="{ name: 'ProfileMenuSettings' }">
              <a href="#" class="dropdown-item">
                <i class="fa fa-sliders-h"></i>
                <span>{{ $t("menu_pref.title") }} </span>
              </a>
            </router-link>
            <a href="#" class="dropdown-item" data-testid="lang-toggle" @click.prevent="toggleLocale()">
              <i class="fa fa-language"></i>
              <span>{{ $t("language.toggle_label") }}</span>
              <span class="badge badge-pill badge-primary ml-2 lang-toggle__badge">{{ nextLocaleLabel }}</span>
            </a>
            <div class="dropdown-divider"></div>
            <a href="#!" class="dropdown-item" @click="logout()">
              <i class="ni ni-user-run"></i>
              <span>{{ $t("auth.signout") }}</span>
            </a>
          </template>
        </base-dropdown>
      </ul>
    </div>
  </base-nav>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import { BaseNav, Modal } from "@/components";
import { mapActions, mapGetters } from "vuex";
import { deleteAuthCookie } from "@/util/auth-cookie";
import PageTaskbar from "@/components/Taskbar/PageTaskbar.vue";
import { nextLocale, localeLabel } from "@/utils/locale";

export default {
  components: {
    CollapseTransition,
    BaseNav,
    Modal,
    PageTaskbar
  },
  props: {
    type: {
      type: String,
      default: "default", // default|light
      description:
        "Look of the dashboard navbar. Default (Green) or light (gray)"
    }
  },
  mounted() {
	this.$i18n.locale = this.getLocale;
  },
  computed: {
    ...mapGetters({
      getUser: "Auth/getUser" ,
	  getLocale: "Auth/getLocale"
    }),
    // The badge on the language toggle names the language a click switches TO
    // (spec 2026-10-06 L2), so one item replaces the old pair of buttons.
    nextLocaleLabel() {
      return localeLabel(nextLocale(this.$i18n.locale));
    },
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    }
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: ""
    };
  },
  methods: {
    ...mapActions({
      signOut: "Auth/signOut",
      setLocale: "Auth/setLocale"
    }),
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    logout() {
      // Delete the cookie at the parent-domain scope used at login
      // (.madamefin.com) so it actually disappears from /files/...
      // requests, not just the BO host entry.
      deleteAuthCookie(this.$cookie);
      this.signOut();
      this.$router.push("/login");
    },
	th() {
      this.$i18n.locale = "th";
      this.setLocale("th");
    },
    en() {
      this.$i18n.locale = "en";
      this.setLocale("en");
    },
    toggleLocale() {
      if (this.$i18n.locale === "th") this.en();
      else this.th();
    }
  }
};
</script>
<style lang="scss" scoped>
/* A flex child only shrinks below its content width when min-width is 0 —
   without this the taskbar refuses to shrink and pushes the user menu
   off the right edge as soon as a few tabs are open.
   Bootstrap 4.0 ships no utility for it. */
.navbar-brand-row,
.min-width-0 {
	min-width: 0;
}
/* The badge is inline-block; its box sits ~2.6px under the label's text
   centre in Chrome (verifier render 2026-10-06). Middle-align it. */
.lang-toggle__badge {
	vertical-align: middle;
}
</style>
<style lang="scss">
/* Compact top bar (2026-10-03). Bootstrap's `.navbar` pads 1rem top AND bottom
   around ~28px of content: a ~62px band of blue that used to hold one line of
   title. Now that the taskbar lives here instead, the bar is trimmed to a
   browser tab-strip.

   Round 2 (2026-10-06, docs/specs/2026-10-06-bo-taskbar-fill-keepalive-design.md
   §2.1 A7/A8, owner: "ที่ให้ขยายเป็นความสูง ชิดด้านบน ล่าง และซ้าย"): no vertical
   padding at all and a 36px floor, so the bar is exactly as tall as a tab and
   the tabs (which stretch to it) sit flush against its top and bottom edges;
   the container's left gutter is gone so the first tab starts at the left
   edge. Round 1 had .25rem padding and a 46px floor. The floor stays a
   min-height, so a taller control would still grow the bar rather than be
   clipped — tests/unit/navbarHeight.spec.js checks none is taller.

   NOT scoped, and `.navbar.navbar-top` on purpose:
     - the inner .nav-link belongs to BaseNav's template, so it never carries
       this component's data-v attribute and a scoped rule cannot reach it;
     - `.navbar-top` alone is (0,1,0), the same as bootstrap's `.navbar`, so it
       would only win on stylesheet order — which is not ours to guarantee from
       a component. (0,2,0) wins outright.
   tests/unit/navbarHeight.spec.js resolves the real cascade and fails if this
   ever stops winning. */
.navbar.navbar-top {
	padding-top: 0;
	padding-bottom: 0;
	min-height: 36px;

	/* Every flex level between the <nav> and a tab stretches, so the 36px
	   reaches the tab (bootstrap centres each level by default). The
	   right-hand user-menu group stretches too but keeps its own
	   .align-items-center, so those controls stay vertically centred.
	   padding-left: !important because argon's
	   `@media (min-width: 768px) .main-content .container-fluid` sets 30px
	   !important (0,2,0); this selector is (0,3,0). */
	> .container-fluid {
		padding-left: 0 !important;
		align-self: stretch;
		align-items: stretch;
	}

	/* min-width: 0 — BaseNav's .navbar-collapse is a flex item, and a flex
	   item's default min-width is its content's width. With 10+ tabs at
	   1366px and the sidebar pinned it grew to ~1540px instead of letting the
	   strip overflow internally: the right-hand group (then EN/TH + the user
	   menu) was pushed off the
	   right edge, the user name wrapped (a 57px bar) and the ‹ › buttons never
	   appeared (verifier, headless Chrome, 2026-10-06). With the floor removed
	   the strip is what shrinks, and the right-hand group keeps its size. */
	.navbar-collapse {
		align-self: stretch;
		align-items: stretch;
		min-width: 0;
	}

	.navbar-collapse > .navbar-nav {
		flex-shrink: 0;
	}

	.navbar-brand-row {
		align-self: stretch;
		margin-left: 0;
		padding-left: 0;
	}

	/* The user menu is the tallest thing in the bar: bootstrap's .nav-link pads
	   .5rem top and bottom, which alone is taller than the band above. */
	.navbar-nav .nav-link {
		padding-top: 0.25rem;
		padding-bottom: 0.25rem;
		/* "ชื่อ นามสกุล" on one line — a wrapped name is a second line of
		   height and breaks the 36px bar. */
		white-space: nowrap;
	}
}
</style>
